import React, {lazy} from 'react'
import {connect} from 'react-redux';
import clsx from 'clsx';

import {withTranslation} from 'react-i18next';
import {
    withStyles,
    Typography,
    Container,
    Grid
} from '@material-ui/core'

const FooterInfo = lazy(() => import("./FooterInfo"));
const QuestionModal = lazy(() => import("./QuestionModal"));
const LegalModal = lazy(() => import("./LegalModal"));
const PrivacyModal = lazy(() => import("./PrivacyModal"));

const useStyles = (theme) => ({
    root: {
        maxWidth: '1440px',
        paddingLeft: '40px',
        paddingRight: '40px',
        [theme.breakpoints.down('md')]: {
            paddingLeft: '10%',
            paddingRight: '10%',
        },
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '24px',
            paddingRight: '24px',
        },
    },
    desktopView: {
        [theme.breakpoints.down('md')]: {
            display: 'none !important',
        },
    },
    mobileView: {
        display: 'none !important',
        [theme.breakpoints.down('md')]: {
            display: 'inherit !important',
        },
    },
    footer: {
        backgroundColor: "#ffffff",
        paddingTop: '3em',
        paddingBottom: '1em',
        width: '100vw'
    },
    footLink: {
        color: "#4f4f4f",
        fontSize: '14px',
        margin: '8px',
        '&:hover': {
            cursor: 'pointer'
        },
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
        },
    },
    privacyLink: {
        color: "black",
        fontSize: '14px',
        fontFamily: 'Noto Sans KR Bold',
        margin: '8px',
        '&:hover': {
            cursor: 'pointer'
        },
    },
    companyInfo: {
        marginTop: "2.5em",
        paddingBottom: "4em",
        // width: '50%',
        [theme.breakpoints.down('md')]: {
            width: '90%',
            paddingBottom: "1em",
        },
    },
    contentTxt: {
        color: "#4f4f4f",
        fontSize: '14px',
        marginTop: '0.7em',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
        },
    },
});

class AppFooter extends React.Component {

    constructor() {
        super();

        this.state = {
            questionModal: false,
            legalModal: false,
            privacyModal: false
        }
    }

    handleChange = event => {
        this.props.setLanguage(event.target.value);
    };

    openLegalModal(show) {
        this.setState({
            legalModal: show
        });
    }

    openPrivacyModal(show) {
        this.setState({
            privacyModal: show
        });
    }

    openQuestionModal(show) {
        this.setState({
            questionModal: show
        });
    }

    render() {
        const { classes, t } = this.props;
        const { questionModal, legalModal, privacyModal } = this.state;

        return (
            <footer className={classes.footer}>
                <Container className={classes.root}>
                    <Grid container spacing={4} justifyContent="flex-start" style={{ marginLeft: '-8px' }}>
                        <Typography className={classes.footLink}
                                    onClick={() => this.openLegalModal(true)}>
                            {t('signup.policy.terms')}
                        </Typography>
                        <Typography className={classes.privacyLink}
                                    onClick={() => this.openPrivacyModal(true)}>
                            {t('HomepageImage.footLink4')}
                        </Typography>
                        <Typography
                            onClick={() => window.open('https://eztrust.notion.site/6a51608705544fa1aa230e588710132d', '_blank')}
                            className={classes.footLink}>
                            {t('HomepageImage.footLink2')}
                        </Typography>
                        <Typography className={classes.footLink}
                                    onClick={() => this.setState({
                                        questionModal: true,
                                    })}>
                            {t('HomepageImage.footLink3')}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Grid item md={12} lg={6} className={classes.companyInfo}>
                            <FooterInfo label={t('HomepageImage.footLabel1')}
                                        content={t('HomepageImage.footContent1')}/>
                            <FooterInfo label={t('HomepageImage.footLabel2')}
                                        content={t('HomepageImage.footContent2')}/>
                            <FooterInfo label={t('HomepageImage.footLabel3')}
                                        content={t('HomepageImage.footContent3')}/>
                            <FooterInfo label={t('HomepageImage.footLabel4')}
                                        content={t('HomepageImage.footContent4')}/>
                        </Grid>
                        <Grid item md={12} lg={6} className={clsx(classes.companyInfo, classes.desktopView)}>
                            <FooterInfo label={''} content={t('HomepageImage.footCompanyName')}/>
                            <FooterInfo label={''} content={t('HomepageImage.footCompanyURL')}/>
                            <FooterInfo label={''} content={t('HomepageImage.footCopyRight')} isCopyRight={true}/>
                        </Grid>
                        <Grid item container direction='column' xs={12}  className={clsx(classes.companyInfo, classes.mobileView)}>
                            <Typography
                                variant="subtitle1"
                                className={classes.contentTxt}
                            >
                                {t('HomepageImage.footCompanyName')}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                className={classes.contentTxt}
                            >
                                {t('HomepageImage.footCompanyURL')}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                className={classes.contentTxt}
                                style={{marginTop: '2.2em', flexBasis: '100% !important'}}
                            >
                                {t('HomepageImage.footCopyRight')}
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
                {
                    questionModal &&
                    <QuestionModal
                        isOpen={questionModal}
                        onClose={() => this.openQuestionModal(false)}
                    />
                }
                {
                    legalModal &&
                    <LegalModal
                        isOpen={legalModal}
                        onClose={() => this.openLegalModal(false)}
                    />
                }
                {
                    privacyModal &&
                    <PrivacyModal
                        isOpen={privacyModal}
                        onClose={() => this.openPrivacyModal(false)}
                    />
                }
            </footer>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.auth.lang
});

export default withTranslation()(connect(mapStateToProps, null)(withStyles(useStyles)(AppFooter)));
